import NavigationLayout from "../navigation/navigation-layout.js";
import BlogList from "./blog-list.js";
import FooterLayout from '../footer/footer-layout.js';
import SectionLayout from "../../layouts/section-layout.js";

const BlogLayout = () => {
    return (
        <>
            <NavigationLayout />

            <SectionLayout children={<BlogList />}/>

            <FooterLayout />
        </>
    );
}

export default BlogLayout;